/**
 * @module
 * @author Bayu Dwiyan Satria
 * @since 1.0.0
 */

/**
 * Libraries
 */
import { createHttpClient } from '@bayudwiyansatria/web-worker'

/**
 * Utilities
 */
import { coreEnv } from '@/core/env'

/**
 * The application's HTTP client.
 *
 * @remarks
 * One instance, bound to the configured base URL. Services import this; components import services.
 * A component that reaches for `fetch` directly is how base URLs, `Accept` headers and error
 * handling end up implemented five slightly different ways in one codebase.
 *
 * The base URL is resolved here rather than inside the package. `coreEnv` reads `import.meta.env`,
 * which is Vite-specific — a published package that did the same would bind itself to one bundler.
 *
 * @example
 * ```ts
 * import { httpClient } from '@/core/http'
 *
 * const health = await httpClient.get<ApiResponse<HealthCheck>>('/health')
 * ```
 */
export const httpClient = createHttpClient({ baseUrl: coreEnv.apiBaseUrl })
